import { motion } from "framer-motion";
import { useSettings } from "@/context/SettingsContext";
import { resolveImage } from "@/lib/api";

const doctorBio = `Médico Otorrinolaringologista CRM-MT 10.467 RQE 6533. Atua na área de Otorrinolaringologia e Medicina do Sono como preceptor do serviço de Residência Médica em Otorrinolaringologia no Hospital Otorrino de Cuiabá-MT.

Atual Membro Titular da Associação Brasileira de Otorrinolaringologia e Cirurgia Cérvico-Facial. Realizou Curso de Capacitação a Preceptores para Ensino de Residentes pela ABORL-CCF (2023). Realizou o XV Curso em Medicina do Sono pela ABORL-CCF (2022).

Possui graduação em Medicina pela União das Faculdades dos Grandes Lagos - UNILAGO (2012-2018) e Residência Médica em Otorrinolaringologia pelo Hospital Otorrino de Cuiabá-MT (2019-2022).

Já trabalhou como médico plantonista das Unidades de Pronto Atendimento (UPA) de Cuiabá-MT, Itapagipe-MG, São José do Rio Preto-SP e José Bonifácio-SP e como médico do trabalho da HB Saúde Medicina Ocupacional.

Realizou estágio extracurricular em Otorrinolaringologia na Santa Casa de Misericórdia de São José do Rio Preto (2018).

Foi membro fundador e diretor de comunicação do Centro Acadêmico Professor Doutor Riad Naim Younes. Membro fundador, Diretor Científico, Diretor Financeiro e Presidente da Liga Acadêmica de Cirurgia Cérvico-Facial do Centro Acadêmico Professor Doutor Riad Naim Younes.

Realizou os cursos de ACLS - Advanced Cardiovascular Life Support Course (2018-2020) e BLS for Healthcare Providers Course (2018-2020).

Durante as atividades acadêmicas realizou monitoria em Histologia pela Faculdade de Medicina da União das Faculdades dos Grandes Lagos - UNILAGO (2015).

Área de atuação: Medicina. Otorrinolaringologia. Medicina do Sono.`;

const PageHeader = ({ kicker, title, subtitle }) => (
  <section className="bg-gradient-to-br from-primary via-primary to-primary/85 text-primary-foreground pt-28 md:pt-32 pb-12 md:pb-16 relative overflow-hidden">
    <div className="absolute inset-0 pattern-grid opacity-30" />
    <div className="absolute -top-20 -right-20 w-80 h-80 bg-accent blob" />
    <div className="container-pad relative">
      <div className="inline-flex items-center gap-2 mb-3">
        <span className="w-8 h-px bg-accent" />
        <span className="text-[11px] tracking-[0.3em] text-accent font-semibold uppercase">{kicker}</span>
      </div>
      <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-light leading-tight mb-3 text-balance max-w-3xl">{title}</h1>
      {subtitle && <p className="max-w-2xl text-primary-foreground/75 text-sm md:text-base">{subtitle}</p>}
    </div>
  </section>
);

const Sobre = () => {
  const { settings } = useSettings();
  const d = settings.doctor;

  return (
    <div data-testid="sobre-page">
      <PageHeader kicker="SOBRE MIM" title={d?.name} subtitle="Atendimento médico em Otorrinolaringologia e Medicina do Sono" />
      <section className="container-pad py-14 md:py-20">
        <div className="grid lg:grid-cols-5 gap-10 items-start">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="lg:col-span-2">
            <div className="aspect-[4/5] rounded-3xl overflow-hidden ring-medical">
              <img src={resolveImage(d?.photo)} alt={d?.name} className="w-full h-full object-cover" />
            </div>
            <div className="mt-5 p-5 bg-gradient-to-br from-secondary to-secondary/40 rounded-2xl border-l-4 border-accent">
              <div className="text-[11px] uppercase tracking-widest text-primary mb-1">Registro Profissional</div>
              <div className="font-display text-lg text-primary font-semibold">CRM-MT 10.467 RQE 6533</div>
              <div className="text-xs text-muted-foreground mt-1.5">Medicina · Otorrinolaringologia · Medicina do Sono</div>
            </div>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.15 }} className="lg:col-span-3">
            <h2 className="font-display text-2xl md:text-4xl text-primary mb-5 text-balance font-light">Trajetória dedicada à <span className="text-gradient-medical font-medium">excelência</span></h2>
            <div className="prose prose-sm md:prose-base max-w-none text-foreground/80 leading-relaxed space-y-4">
              {doctorBio.split("\n\n").map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
            <div className="mt-8 p-6 md:p-8 bg-gradient-to-br from-accent/10 to-accent/5 rounded-3xl border border-accent/20">
              <div className="text-[11px] uppercase tracking-widest text-accent mb-2 font-semibold">Nota do médico</div>
              <p className="font-display text-lg md:text-xl italic text-primary leading-relaxed">"{d?.quote}"</p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Sobre;
